export function getPublicApiAuthToken() {
  return process.env.VUE_APP_WEBSITE_AUTH_TOKEN || ''
}

export function publicApiAuthHeaders() {
  const token = getPublicApiAuthToken()

  return token ? { Authorization: token } : {}
}
